import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from 'semantic-ui-react';
import { isEmpty } from 'lodash';
import DataTable from '../tables/DataTable';
import withTable from '../tables/withTable';
import { 
  loadBuyerPurchased, resetBuyerArbitration, resetBuyerPurchased, resetInspectionStatus
} from '../../actions';
import { getConfig, compose } from '../../utils/helpers';
import styles from './styles';
import { toastr } from 'react-redux-toastr';
import TransportationModal from '../transportation/TransportationModal';
import { ArbitrationModal } from '../arbitration';
import { transportationMpFeatures } from '../transportation';
import InspectionModal from '../inspection/InspectionModal';

class BuyerPurchased extends Component {
  
  constructor(props) {
    super(props);
    this.loadData();
    // transportation providers
    const features = (props.marketplaceFeatures?.features || '').split(',');
    const enabledTransportProviders = features
      .filter(feat => transportationMpFeatures[feat])
      .map(feat => transportationMpFeatures[feat]);
    
    this.state = {
      title: 'purchased',
      enabledTransportProviders,
      isTransportationModalOpen: false,
      isArbitrationModalOpen: false,
      isInspectionModalOpen: false,
      itemForInspection: {
        itemId: '',
        inspectionProcessingStatus: 0,
        inspectionProcessingStatusText: '',
        transactionId: 0
      },
      itemToBeShipped: {
        itemId: '',
        vehicleZip: '',
        vin: '',
      },
      itemSelectedForArbitration: {
        arbitrationStatus: '',
        enableRequestArbitration: 0, 
        enableAddArbitrationComment: 0, 
        enableCancelArbitration: 0,
        itemId: '', 
        rowIndex: null,
      }
    }
  }

  loadData = () => {
    this.props.resetBuyerPurchased();
    this.props.loadBuyerPurchased(getConfig('marketplaceId'));
  };

  handleArbitrationRefresh = () => {
    const {
      arbitrationStatus, 
      enableRequestArbitration, 
      enableAddArbitrationComment, 
      enableCancelArbitration,
      rowIndex,
      itemId
    } = this.props.buyerPurchased.data[this.state.itemSelectedForArbitration.rowIndex];
    this.setState({
      itemSelectedForArbitration: {
        arbitrationStatus, 
        enableRequestArbitration, 
        enableAddArbitrationComment, 
        enableCancelArbitration,
        rowIndex,
        itemId
      }
    })
  }

  handleCompleteTransportation = checkoutUrl => {
    window.open(checkoutUrl, '_blank');
  };

  handleDetailsClick = (itemId, data) => {
    const path = `/item/${itemId}`;
    this.props.navigate(path);
    const ids = (data || [])
      .map(item => item.itemId || item.id || item._id)
      .join(',');
    sessionStorage.setItem('navItems', ids);
  };

  onArbitrationClick = (e) => {
    e.preventDefault();
    const rowIndex = Number(e.target.dataset.vehicleIndex);
    const rowData = this.props.buyerPurchased.data[rowIndex];
    const {
      arbitrationStatus, 
      enableRequestArbitration, 
      enableAddArbitrationComment, 
      enableCancelArbitration,
      itemId, 
    } = rowData;
    this.setState({
      itemSelectedForArbitration: {
        arbitrationStatus, 
        enableRequestArbitration, 
        enableAddArbitrationComment, 
        enableCancelArbitration,
        itemId, 
        rowIndex,
      },
    }, () => this.setState({isArbitrationModalOpen: true}))
  }

  onShippingClick = (e) => {
    e.preventDefault();
    const rowIndex = Number(e.target.dataset.vehicleIndex);
    const rowData = this.props.buyerPurchased.data[rowIndex];
    const {buyerNumber, itemId, vehicleYear, make, model, amount, listingStatus, listingStatusId, status, vin, vehicleZip, shippingStatusId, vehicleAddress, vehicleCity, vehicleState } = rowData;
    const rowDataParsed = {buyerNumber, itemId, vehicleYear, make, model, amount, listingStatus, listingStatusId, status, vin, vehicleZip, shippingStatusId, vehicleAddress, vehicleCity, vehicleState }
        
    this.handleShippingClick(rowDataParsed);
  }

  onInspectionClick = (e) => {
    e.preventDefault();
    const rowIndex = Number(e.target.dataset.vehicleIndex);
    const {itemId, inspectionProcessingStatus, inspectionStatusText, transactionId} = this.props.buyerPurchased.data[rowIndex];
    const itemData = {itemId, inspectionProcessingStatus, inspectionStatusText, transactionId};
    this.setState({itemForInspection: itemData}, () => this.setState({isInspectionModalOpen: true}))
  }

  handleCloseArbitrationModal = () => {
    this.props.loadBuyerPurchased(getConfig('marketplaceId'))
    this.setState({isArbitrationModalOpen: false});
  }

  handleCloseInspectionModal = () => {
    this.props.loadBuyerPurchased(getConfig('marketplaceId'))
    this.setState({isInspectionModalOpen: false});
  }

  handleShippingClick = async (rowData) => {
    const vehicleZip = rowData?.vehicleZip;
    if (!vehicleZip) {
      toastr.error(
        'Shipping quote error',
        'Origin ZIP code not found or is invalid',
        {position: 'top-center'}
      );
    } else {
      this.setState({
        itemToBeShipped: {
          ...rowData, 
          vehicleZip, 
          shippingDetails: { 
            shippingStatusId: rowData.shippingStatusId
          },
        }
      }, 
        () => this.setState({
          isTransportationModalOpen: true
        }, 
          () => this.loadData()
        ));
    }
  }

  renderArbitrationModal = ({
    arbitrationStatus,
    itemId, 
    enableAddArbitrationComment, 
    enableCancelArbitration, 
    enableRequestArbitration
  }) => {
    return (
      <ArbitrationModal
        arbType={'buyer'}
        arbitrationStatus={arbitrationStatus}
        enableRequestArbitration={enableRequestArbitration}
        enableAddArbitrationComment={enableAddArbitrationComment}
        enableCancelArbitration={enableCancelArbitration}
        isOpen={this.state.isArbitrationModalOpen}
        itemId={itemId}
        onAgreedToTerms={this.handleArbitrationRefresh}
        onClose={this.handleCloseArbitrationModal}
        onOpen={()=>null}
      />
    )
  }

  renderInspectionModal = (itemForInspection) => {
    return (
      <InspectionModal
        itemData={itemForInspection}
        mpId={getConfig('marketplaceId')}
        isOpen={this.state.isInspectionModalOpen}
        onClose={this.handleCloseInspectionModal}
      />
    )
  }

  renderShippingModal = (itemToBeShipped) => {
    const {enabledTransportProviders, isTransportationModalOpen, isArbitrationModalOpen} = this.state;
    const {user} = this.props.userProfile;
    return (
      <TransportationModal
          itemData={itemToBeShipped}
          mpId={getConfig('marketplaceId')}
          user={user}
          isOpen={isTransportationModalOpen}
          onClose={() => this.setState({ isTransportationModalOpen: false })}
          providers={enabledTransportProviders}
      />
    )
  }

  makeActionButtons = (data) => {
    return {
      Header: 'Actions',
      id: 'buttons',
      headerStyle: { background: 'none' },
      sortable: false,
      filterable: false,
      Cell: row => {
        const defaultButtonColor = styles.button.backgroundColor;
        const features = (this.props.marketplaceFeatures.features || '').split(',');
        // Arbitration
        const {enableRequestArbitration, enableCancelArbitration, enableAddArbitrationComment} = row.original;
        const showArbitrationButton = 
          (getConfig('enableBuyerSellerArbitration') === true)
          && Boolean(enableRequestArbitration || enableCancelArbitration || enableAddArbitrationComment);
        // Transportation
        const showShippingButton = features.some(feat=>Object.keys(transportationMpFeatures).includes(feat));  
        const isShippingRequested = ![0,1].includes(row.original?.shippingStatusId);
        const isPsiOrdered = row.original?.psiOrdered === 1;
        const psiProcessingStatus = row.original?.inspectionProcessingStatus ?? -1;
        const showCompletePurchaseButton = !!row.original.checkoutUrl;
        // Gatepass
        const isPaymentInProgress = row.original.paymentStatusId === 2 || row.original.paymentStatus === 'In Progress';
        const isPaymentAccepted = row.original.paymentStatusId === 3 || row.original.paymentStatus === 'Accepted';
        const showGatepassButton = 
          /* Payment Status is: 'Accepted'|'In Progress'  AND  Transaction Status is 'In Progress' or Complete */
          (isPaymentAccepted || isPaymentInProgress) && 
          ([2,4].includes(row.original.transactionStatusId))
        return (
          <div style={{...styles.buttonGroup, height: 150}}>
            {/* "View Details" */}
            <Button
              style={styles.button}
              onClick={() =>
                this.handleDetailsClick(row.original.itemId, data)
              }
            >
              View Details
            </Button>

            {/* buyerReceipt - "Bill of Sale" */}
            {row.original.buyerReceipt && (
              <a
                style={styles.button}
                href={getConfig('apiRoot') + row.original.buyerReceipt}
              >
                Bill of Sale
              </a>
            )}

            {/* gatePass - "Gatepass" link */}
            {(row.original.gatePass && showGatepassButton) && (
              <a
                style={styles.button}
                href={getConfig('apiRoot') + row.original.gatePass}
              >
                Gatepass 
              </a>
            )}

            {/* "Shipping" */}
            {showShippingButton
              ? (
                <Button 
                  style={{
                    ...styles.button, 
                    backgroundColor: isShippingRequested ? styles.active.button : defaultButtonColor
                  }}
                  onClick={this.onShippingClick}
                  data-vehicle-index={row.index}
                  title={isShippingRequested ? "Transport has been requested" : "Request Transport Service"}
                > 
                  {isShippingRequested ? "Shipping \u{2714}" : "Shipping ..."}
                </Button> 
              )
              : null
            }

            {/* "Inspection" */}
            { isPsiOrdered ? (
                <Button
                style={{
                  ...styles.button, 
                  backgroundColor: [3].includes(psiProcessingStatus) ? styles.complete.button : [0,1,2].includes(psiProcessingStatus)? styles.active.button : defaultButtonColor
                }}
                  onClick={this.onInspectionClick}
                  data-vehicle-index={row.index}
                  title="Post Sale Inspection"
                >
                  Inspection...
                </Button>
              )
              :null
            }

            {/* Receipt Report */}
            {row.original.buyerReceiptReport && (
              <a
                style={styles.button}
                href={getConfig('apiRoot') + row.original.buyerReceiptReport}
              >
                Receipt Report
              </a>
            )}
            {/* Arbitration */}
            {showArbitrationButton && (
              <Button 
                style={{
                  ...styles.button, 
                  backgroundColor: enableAddArbitrationComment ? styles.active.button : defaultButtonColor,
                }} 
                onClick={this.onArbitrationClick}
                data-vehicle-index={row.index}
                title={"Edit, view, or new Arbitration"}
              >
                Arbitration
              </Button>
            )}
            {/* TODO - 4.16.2024 -- Remove; Transport services not handled directly in MP */}
            {showCompletePurchaseButton && (
              <div style={{ width: '100%' }}>
                <Button
                  style={{
                    ...styles.button,
                    margin: 0,
                    padding: 4,
                    height: 'auto',
                  }}
                  onClick={e =>
                    this.handleCompleteTransportation(
                      row.original.checkoutUrl
                    )
                  }
                >
                  Complete Transportation
                </Button>
              </div>
            )}
          </div>
        );
      },
    }
  }

  render() {
    const loading = isEmpty(this.props.buyerPurchased);
    const data = this.props.buyerPurchased.data || [];
    const columns = this.props.makeColumns([
      'checkbox',
      'image',
      this.makeActionButtons(data),
      'vin',
      'year',
      'make',
      'model',
      'amount',
      'buyFee',
      'seller',
      'buyer',
      'purchaseDate',
      'paymentStatus',
      // 'arbitrationStatus', // 2024.10.07 - disabling column temporarily
      'titleStatus',
      'eventName',
      'lotNumber',
    ]);
    const {itemToBeShipped, itemSelectedForArbitration, itemForInspection} = this.state;

    return (
      <div className="st-container shadow padding background-white padding">
        {this.renderShippingModal(itemToBeShipped)}
        {this.renderArbitrationModal({...itemSelectedForArbitration})}
        {this.renderInspectionModal(itemForInspection)}
        <h4>Purchased Vehicles</h4>
        <DataTable
          loading={loading}
          title={this.state.title}
          data={data}
          columns={columns}
          showCSVButton={true}
          showPrintButton={true}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { 
    buyerPurchased,
    marketplaceFeatures, 
    userProfile 
  } = state.entities;
  return { 
    buyerPurchased, 
    marketplaceFeatures,
    userProfile
  };
};

export default compose(
  withTable,
  connect(mapStateToProps, { 
    loadBuyerPurchased, resetBuyerPurchased, resetBuyerArbitration, resetInspectionStatus
  })
)(BuyerPurchased);
